import React from "react"
import Link from "gatsby-link"
import { Helmet } from "react-helmet"
import Markdown from "../../components/Markdown"
import DilemmaList from "../../components/DilemmaList"
import ReviewList from "../../components/ReviewList"
import * as PropTypes from "prop-types"

import style from "./index.module.css";

const propTypes = {
  data: PropTypes.object.isRequired,
}

class Boek extends React.Component {
  render() {
    const content = this.props.data.page.edges[0].node

    var book = content.book ? content.book[0] : false;
    var bookPreview = (book.preview && book.preview.file.url) ? book.preview.file.url : false;
    var dilemmas = content.dilemmas ? content.dilemmas : false;
    var reviews = book.reviews ? book.reviews : false;
    return (
      <div>
        <Helmet>
          <title>{content.title}</title>
          <meta name="description" content={content.metaDescription} />
          <meta property="og:title" content={content.title} />
          <meta property="og:description" content={content.metaDescription} />
        </Helmet>
        {content.body &&
          <Markdown className={style.article} source={content.body.body} />
        }
        {book &&
          <section className={style.book}>
            <div className={style.coverContainer}>
              {book.cover &&
                <img
                  className={style.cover}
                  src={`${book.cover.file.url}?w=300`}
                  srcSet={`
                    ${book.cover.file.url}?w=300 300w,
                    ${book.cover.file.url}?w=410 410w,
                    ${book.cover.file.url}?w=615 615w,
                    ${book.cover.file.url}?w=820 820w
                  `}
                  width="410"
                />
              }
              {bookPreview &&
                <a className={style.bookPreviewLink} href={book.preview.file.url} target="_blank">Neem een kijkje in het boek</a>
              }
            </div>
            <div className={style.bookContent}>
              {book.title &&
                <h1 className={style.bookTitle}>{book.title}</h1>
              }
              {book.body.body &&
                <Markdown className={style.article} source={book.body.body} />
              }
              <div className={style.bookDetails}>
                {book.isbn &&
                  <div className={style.bookDetailItem}>ISBN: {book.isbn}</div>
                }
                {book.price &&
                  <div className={style.bookDetailItem}>Prijs: {book.price}</div>
                }
                {book.publisher &&
                  <div className={style.bookDetailItem}>Uitgever: {book.publisher}</div>
                }
              </div>
              {book.orderLink &&
                <Link className={style.bookLink} to={book.orderLink}>Bestel het boek</Link>
              }
            </div>
          </section>
        }
        {dilemmas &&
          <section className={style.dilemma}>
            <h1>Badkamerdilemma's</h1>
            <DilemmaList items={content.dilemmas} />
          </section>
        }
        {reviews &&
          <section className={style.reviews}>
            <ReviewList items={reviews} />
          </section>
        }
      </div>
    )
  }
}

Boek.propTypes = propTypes

export default Boek

export const bookPageQuery = graphql`
  query bookPageQuery {
    page: allContentfulPageBook {
      edges {
        node {
          title
          metaDescription
          book {
            title
            subtitle
            body {
              body
            }
            cover {
              file {
                url
              }
            }
            isbn
            price
            publisher
            orderLink
            preview {
              file {
                url
              }
            }
          }
          dilemmas {
            title
            slug
            type
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/boek/index.js